export const BEEKEEPER_TASKS = 'tasks';
export const BEEKEEPER_TASKS_LITE = 'tasks_lite';
